// Web stub. The native module is never resolved on web (see lib/ads.web.ts
// for the same pattern). All purchase APIs no-op so the rest of the app
// can call them unconditionally.

export type PurchaseOutcome = 'purchased' | 'cancelled' | 'failed';

export const initializeRevenueCat = async (): Promise<void> => {};
export const isRevenueCatInitialized = () => false;
export const getRemoveAdsPackage = async () => null;
export const getRemoveAdsPackageWithReason = async () => ({
  package: null,
  reason: 'web platform' as const,
});
export const purchaseRemoveAds = async (): Promise<{
  outcome: PurchaseOutcome;
  entitled: boolean;
}> => ({ outcome: 'failed', entitled: false });
export const restorePurchases = async (): Promise<{ entitled: boolean }> => ({
  entitled: false,
});
export const checkEntitlement = async (): Promise<boolean> => false;
export const addEntitlementListener = (_listener: (entitled: boolean) => void) => () => {};
export const resetRcUserForTesting = async (): Promise<{
  entitled: boolean;
  userId: string;
} | null> => null;

export default {
  initializeRevenueCat,
  isRevenueCatInitialized,
  getRemoveAdsPackage,
  getRemoveAdsPackageWithReason,
  purchaseRemoveAds,
  restorePurchases,
  checkEntitlement,
  addEntitlementListener,
  resetRcUserForTesting,
};
